import ConfirmationDlg from "../../../../components/ConfirmationDlg";


function ModalOTP({ open, onClose, onConfirm, data }) {
  return (
    <ConfirmationDlg
      title="Verify Whatsapp"
      open={open}
      onClose={onClose}
      onSubmit={onConfirm}
      btnSubmitText="Verify"
      btnCancelText="Cancel"
      confirmButtonClass="btn btn-sm btn-outline-theme"
      cancelButtonClass="btn btn-sm btn-outline-danger"
    >
      <p>Are you sure you want to verify this user?</p>
      <p>Name: {data?.firstname + " " + data?.lastname}</p>
      <p>Number: {data?.phone}</p>
      <p className="alert alert-info">We will send an OTP to this number to verify it. please reply the message with the number provided to verify it.</p>
    </ConfirmationDlg>
  );
}

export default ModalOTP;
